export class ApplicantDetails {
    CustomerId: number;
    NameTitle: string;
    Name: string;
    S_W_DoFTitle: string;
    S_W_DoF: string;
    Age: number;
    DateOfBirth: string;
    DateOfBirth1: string;
    Gender: string;
    Address: string;
    Nationality: string;
    AadharNumber: string;
    PassportNumber: string;
    MobileNo: string;
    EmailId: string;
    EmailId1: string;
    State: string;
    Country: string;
    City: string;
    Pincode: string;
    Name1: string;
    S_W_DoF1: string;
    S_W_DoFTitle1: string;
    Nationality1: string;
    AadharNumber1: string;
    PassportNumber1: string;
    CIN: string;
    CINNumber: string;
    ApplicantType: string;
    CountryCode: number;
    CountryID: number;
    AuthPersonName: string;
    AuthPersonAadharNo: string;
    TransactionNo:string;
    CommunicationAddress:string;
    CommunicationCity:string;
    CommunicationState:string;
    CommunicationPinCode:string;
    CommunicationCountryID:number;
    CommunicationCountry:string;
    PrefixCode: number;
    IsKYCApproved: boolean;
    IsSameAsPermanentAddress: boolean;
    IsRequestedForChange: boolean;
    SecondaryApplicantAddress:string;
    SecondaryApplicantCity:string;
    SecondaryApplicantState:string;
    SecondaryApplicantPincode:string;
    SecondaryApplicantCountryID:number;
    SecondaryApplicantCountry:string;
    SecondaryApplicantCommunicationAddress:string;
    SecondaryApplicantCommunicationCity:string;
    SecondaryApplicantCommunicationState:string;
    SecondaryApplicantCommunicationPincode:string;
    SecondaryApplicantCommunicationCountryID:number;
    SecondaryApplicantCommunicationCountry:string;
    IsSameASPermanentAddressForSecondaryApplicant:boolean;
    HasReopenRequest: boolean;
    AlternateMobileNumber: string;
    SecondaryApplicantAlternateMobileNumber: string;
    SecondaryApplicantPrimaryMobileNumber: string;
}
